import styled from 'styled-components'
import { tokens } from '../../styles/tokens'
import { FormField, Input } from './FormField'

interface Translation {
  locale: string
  name: string
}

interface Props {
  translations: Translation[]
  onChange: (translations: Translation[]) => void
}

const LocaleTag = styled.span`
  display: inline-block;
  background: ${tokens.purple100};
  color: ${tokens.purple600};
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 2px 7px;
  border-radius: 4px;
  margin-bottom: 8px;
`

const LOCALES = ['en', 'es']

export function TranslationFields({ translations, onChange }: Props) {
  const update = (locale: string, name: string) => {
    const existing = translations.find(t => t.locale === locale)
    if (existing) {
      onChange(translations.map(t => (t.locale === locale ? { ...t, name } : t)))
    } else {
      onChange([...translations, { locale, name }])
    }
  }

  return (
    <>
      {LOCALES.map(locale => (
        <FormField key={locale} label={`Name (${locale === 'en' ? 'English' : 'Spanish'})`}>
          <LocaleTag>{locale}</LocaleTag>
          <Input
            placeholder={locale === 'en' ? 'Enter name in English' : 'Ingresa el nombre en español'}
            value={translations.find(t => t.locale === locale)?.name ?? ''}
            onChange={e => update(locale, e.target.value)}
          />
        </FormField>
      ))}
    </>
  )
}
